import { Component, Fragment } from "react";
import { NHCPinoutDevices } from "src/model/api/nhc-pinout-devices";
import { ts } from "src/utils/translate"
import { NHCPinoutElement } from "src/pages/OfferPage/pinouts/NHCPinout/NHCPinoutElement";

interface NHCPinoutProps {
  projectId: string | undefined;
  nhcPinoutData: NHCPinoutDevices;
}

interface NHCPinoutState {
  data: any[];
  ipDevices: any[];
}

export class NHCPinout extends Component<NHCPinoutProps,NHCPinoutState> {

  constructor(props: NHCPinoutProps) {
    super(props);
    this.state = {
      data: [],
      ipDevices: [],
    };
  }

  render() {
    const { nhcPinoutData } = this.props;

    const nhcDinDevices: any[] = [];
    let page = 1;
    const pages = [1];
    const startPosition = 20;
    const x_margin = 0;
    const svgWidth = 885;

    let x_position = startPosition;
    let y_position = 200;

    let row = 1;
    let countedUnitNumber = 0;
    let needNewRow = false;
    let ipDevices: any[] = [];

    const hasPinoutElements =
        nhcPinoutData != null &&
        Array.isArray(nhcPinoutData.pinoutElements) &&
        nhcPinoutData.pinoutElements.length > 0;

    if (hasPinoutElements) {
      nhcPinoutData.pinoutElements.map( (item, index) => {

        ipDevices = (nhcPinoutData)['ipDevices'];

        countedUnitNumber += item.din;

        let elements = [];

        if (item.din_name === 'DALI-2 broadcast module, 2 channels' || item.din_name === 'DALI-2 addressable module, 2 channels') {
          elements = item.lines ? item.lines : [];
        }
        else {
          elements = item.elements ? item.elements : [];
        }

        if (item.hasOwnProperty('row')) {
          needNewRow = true;
          row = item.row;
        }
        else {
          if (index > 0) {
            row = 0;
          }

          if (x_position + item.original_width + x_margin > (svgWidth - ( x_margin * 2 ))) {
            needNewRow = true;
          }
          else if (countedUnitNumber > 24) {
            needNewRow = true;
          }

        }

        if (needNewRow) {
          needNewRow = false;
          countedUnitNumber = item.din;
          x_position = startPosition;
          pages.push( ++page );
        }

        const nhcDinDevice = {
          name: item.din_name,
          image: item.image,
          original_width: item.original_width,
          original_height: item.original_height,
          x_position: x_position,
          y_position: y_position,
          page: page,
          elements: elements,
          coordinates: item.coordinates ? item.coordinates : [],
          direction: item.direction,
          xOffset: x_position,
          row: row,
          need_usb_to_main_device: (item.need_usb_to_main_device && item.din_name == 'Connected controller for Niko Home Control II') ? true: false
        };

        x_position += item.original_width + x_margin;

        nhcDinDevices.push(nhcDinDevice);
      })
    }

    return (hasPinoutElements) ? <Fragment>
      {<h3 style={{ fontWeight: 300 }} className="remove-on-export pinout-header">{ts('q_pinout', 'Pinout')}</h3>}
      <div>
        {pages.map( (page, key) => (
            <svg key={key} width="100%" height="800" viewBox="0 0 842 595" className="pinout lightshadow" style={{ height: '1483.97px' }} xmlns="http://www.w3.org/2000/svg"
                 xmlnsXlink="http://www.w3.org/1999/xlink">
              <g>
                <defs><marker id="head" orient="auto" markerWidth="4" markerHeight="4" refX="0.1" refY="2"><path d="M0,0 V4 L4,2 Z" fill="black"></path></marker></defs>
                <text fontSize="8" x="794" y="16" textAnchor="end" fill="lightgrey">{ts('q_safety_text', 'q_safetyText')}</text>
                {nhcDinDevices.map( (dinDevice, key) => (
                  <NHCPinoutElement
                    key={key}
                    page={page}
                    dinDevice={dinDevice}
                    dinDeviceKey={key}
                    xOffset={x_position}
                    ipDevices={ipDevices}
                  />
                ))}
              </g>
            </svg>
        ))}
      </div>
    </Fragment> : '';
  }
}
